import _extends from "@babel/runtime-corejs3/helpers/extends";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { useContext, useEffect } from 'react';
import classnames from 'classnames';
import { ConfigContext } from '../config-provider';
import { getCompProps } from '../_utils';
import useForm, { INTERNAL_HOOK_KEY } from './hooks/useForm';
import FormContext from './FormContext';
import FieldContext from './FieldContext';

var Form = function Form(props, ref) {
  var _context, _classnames;

  var _useContext = useContext(ConfigContext),
      getPrefixCls = _useContext.getPrefixCls,
      prefixCls = _useContext.prefixCls,
      userDefaultProps = _useContext.compDefaultProps,
      globalLocale = _useContext.locale;

  var formProps = getCompProps('Form', userDefaultProps, props);
  var formLang = globalLocale.getCompLangMsg({
    componentName: 'Form'
  });

  var children = formProps.children,
      defaultValues = formProps.defaultValues,
      className = formProps.className,
      form = formProps.form,
      labelAlign = formProps.labelAlign,
      labelWidth = formProps.labelWidth,
      layout = formProps.layout,
      name = formProps.name,
      customizePrefixCls = formProps.prefixCls,
      wrapperWidth = formProps.wrapperWidth,
      onFinish = formProps.onFinish,
      onFinishFailed = formProps.onFinishFailed,
      onValuesChange = formProps.onValuesChange,
      disabled = formProps.disabled,
      restProps = __rest(formProps, ["children", "defaultValues", "className", "form", "labelAlign", "labelWidth", "layout", "name", "prefixCls", "wrapperWidth", "onFinish", "onFinishFailed", "onValuesChange", "disabled"]);

  var formPrefixCls = getPrefixCls(prefixCls, 'form', customizePrefixCls);
  var formClassName = classnames((_classnames = {}, _defineProperty(_classnames, "".concat(formPrefixCls), true), _defineProperty(_classnames, _concatInstanceProperty(_context = "".concat(formPrefixCls, "-")).call(_context, layout), true), _classnames), className);
  var formContext = useContext(FormContext);

  var _useForm = useForm(form),
      _useForm2 = _slicedToArray(_useForm, 1),
      formInstance = _useForm2[0]; // 注册


  useEffect(function () {
    formContext.registerForm(name, formInstance);
    return function () {
      formContext.unregisterForm(name);
    };
  }, [name, formInstance, formContext]); // 暴露 formInstance

  React.useImperativeHandle(ref, function () {
    return formInstance;
  }); // 设置默认值及回调函数

  var _formInstance$getInte = formInstance.getInternalHooks(INTERNAL_HOOK_KEY),
      setDefaultValues = _formInstance$getInte.setDefaultValues,
      setCallbacks = _formInstance$getInte.setCallbacks;

  setDefaultValues(defaultValues);
  setCallbacks({
    onFinish: onFinish,
    onFinishFailed: onFinishFailed,
    onValuesChange: onValuesChange
  });
  var formContextValue = React.useMemo(function () {
    return _extends(_extends({}, formInstance), {
      labelAlign: labelAlign,
      labelWidth: labelWidth,
      wrapperWidth: wrapperWidth,
      local: formLang,
      disabled: disabled,
      vertical: layout === 'vertical'
    });
  }, [formInstance, labelAlign, labelWidth, wrapperWidth, layout, formLang]);

  var handleSubmit = function handleSubmit(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    formInstance.submit();
  };

  var handleReset = function handleReset(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    formInstance.resetFields();
  };

  return /*#__PURE__*/React.createElement("form", _extends({
    className: formClassName
  }, restProps, {
    onSubmit: handleSubmit,
    onReset: handleReset
  }), /*#__PURE__*/React.createElement(FieldContext.Provider, {
    value: formContextValue
  }, children));
};

export default Form;